import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./PaymentVerify.css";
import StaticPageHeaders from "../../../Components/StaticPageHeaders";
import NavbarCustom from "../../../Components/NavbarCustom";
import SEO from "../../../Components/SEO";
import { useSummerCamp } from "../../../APIContext/summerCampContext";
import { useNewUser } from "../../../APIContext/NewUserContext";

import { useNavigate } from "react-router-dom";

const PaymentVerify = () => {
  const { verifyPayment } = useSummerCamp();
  const { verifyPaymentGuest } = useNewUser();
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const sessionID = urlParams.get("session_id");
  const userlg = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      try {
        const result = null;
        if (userlg) {
          const result = await verifyPayment(sessionID);
          if (result && result.status === "success") {
            navigate("/thank-you");
          } else {
            navigate("/thank-you");
          }
        } else {
          const resultGuest = await verifyPaymentGuest(sessionID);
          if (resultGuest && resultGuest.status === "success") {
            navigate("/thank-you");
          } else {
            navigate("/thank-you");
          }
        }
      } catch (error) {
        console.error("Error verifying payment:", error);
      }
    };
    fetchPaymentStatus();
  }, []);

  return (
    <>
      <SEO
        title="Payment Verification - Shootin School Inc"
        description="Payment verification and confirmation for Shootin School services"
        url="https://shootinschool.com/payment-verify"
      />

      <NavbarCustom />
      <StaticPageHeaders title="Verifying your Payment...." />

      <div className="payment-verify-container brightness">
        <div className="loaders-verifyment brightness">
          <div className="box">
            <div className="pulse"></div>
            <p className="text-clip">Verifing...</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentVerify;
